import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Thead, Tr, Th, Tbody, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { FaRegClock } from "react-icons/fa";
import { COURSE_STATUS } from "../../../../utils/constants";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import ConfirmationModal from "../../../common/ConfirmationModal";
import {
  deleteCourse,
  fetchInstructorCourses,
} from "../../../../services/operations/courseDetailsAPI";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../services/formatDate";

function CourseTable({ courses, setCourse, time }) {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(null);
  const navigate = useNavigate();

  async function handleCourseDelete(courseId) {
    setLoading(true);

    await deleteCourse({ courseId: courseId }, token);

    const result = await fetchInstructorCourses(token);

    if (result) {
      setCourse(result);
    }

    setConfirmationModal(null);
    setLoading(false);
  }

  function formatTime(seconds, index) {
    const hours = Math.floor(seconds / 3600);
    const remainingSecondsAfterHours = seconds % 3600;
    const minutes = Math.floor(remainingSecondsAfterHours / 60);
    const remainingSeconds = remainingSecondsAfterHours % 60;
    return { hours, minutes, seconds: remainingSeconds };
  }

  const [hours, setHours] = useState([]);
  const [seconds, setSeconds] = useState([]);

  const [minutes, setMinutes] = useState([]);

  useEffect(() => {
    // console.log(courses);
    let arr = [];
    let arr1 = [];
    let arr2 = [];
    for (let i = 0; i < time.length; i++) {
      const { hours, minutes, seconds } = formatTime(time[i]);
      arr.push(hours);
      arr1.push(minutes);
      arr2.push(seconds);
    }
    setHours(arr);
    setSeconds(arr1);
    setMinutes(arr2);
  });

  useEffect(() => {}, [confirmationModal]);

  return (
    <div className="text-white mt-10">
      <Table className="rounded-xl border border-richblack-800">
        <Thead className="flex">
          {/* Tr  */}
          <Tr className="flex gap-x-56 max-[450px]:gap-x-10 px-6 max-[450px]:px-1 py-2 border border-richblack-800 p-8">
            <Th className="flex-1 text-left text-sm font-medium uppercase text-richblack-100">
              Course
            </Th>
            <Th className="flex-1 text-left translate-x-0 lg:translate-x-10 text-sm font-medium uppercase text-richblack-100">
              Duration
            </Th>
            <Th className="flex-1 text-left text-sm font-medium uppercase text-richblack-100">
              Price
            </Th>
            <Th className="flex-1 text-left text-sm font-medium uppercase text-richblack-100">
              Actions
            </Th>
          </Tr>
        </Thead>
        <Tbody className="flex flex-col">
          {courses.length === 0 ? (
            <Tr>
              <Td>No Course Found</Td>
            </Tr>
          ) : (
            courses.map((course, index) => {
              return (
                <Tr
                  key={course._id}
                  // tr p-8
                  className="flex gap-x-32 border items-center justify-between border-richblack-800 px-6 py-8">
                  <Td className="flex flex-1 gap-x-4 ">
                    {/* td items-center */}
                    {/* <div className='flex gap-x-4'> */}
                    <div>
                      <img
                        src={course?.thumbnail}
                        alt=""
                        className="h-20 w-32 max-[450px]:w-[80%] rounded-lg object-cover"
                      />
                    </div>
                    <div className="flex flex-col justify-between">
                      <p className="text-lg font-semibold text-richblack-5">
                        {course.courseName}
                      </p>
                      <p className="text-xs max-[450px]:text-sm text-richblack-300">
                        {course.courseDescription}
                      </p>
                      <p className="text-[12px] max-[450px]:text-lg text-white">
                        Created: {formatDate(course?.createdAt)}
                      </p>
                      {course.status === COURSE_STATUS.DRAFT ? (
                        <p className="flex mt-1 w-[80%] gap-x-2 items-center justify-center bg-richblack-700 rounded-lg text-pink-100 py-1 px-4">
                          <FaRegClock /> Drafted
                        </p>
                      ) : (
                        <p className="flex mt-1 w-[80%] gap-x-2 items-center justify-center bg-richblack-700 text-yellow-100 rounded-lg py-1 px-4">
                          <FaCheck /> Published
                        </p>
                      )}
                    </div>
                    {/* </div> */}
                  </Td>
                  <Td className="-translate-x-24 flex flex-col max-[450px]:translate-x-0">
                    {/* 2hr 30min */}
                    
                    
                    <p className="">
                      H:
                    {
                      // time[index]
                      // formatTime(time[index])
                      isNaN(hours[index]) ? 0 : hours[index]
                    }
                      {" " } M:
                    {
                      isNaN(minutes[index]) ? 0 : minutes[index]
                    }
                    {" " }
                    S:
                    {
                      isNaN(seconds[index]) ? 0 : seconds[index]
                    }
                    </p>
                  </Td>
                  <Td className="text-sm -translate-x-10 max-[450px]:translate-x-0 font-medium text-richblack-5">
                    <p>Rs.₹{course.price}</p>
                  </Td>
                  <Td className="flex gap-x-4">
                    <button
                      className="flex gap-x-2 items-center"
                      disabled={loading}
                      onClick={() => {
                        navigate(`/dashboard/edit-course/${course._id}`);
                      }}>
                      Edit <MdModeEdit />
                    </button>
                    <button
                      className="flex gap-x-2 items-center"
                      disabled={loading}
                      onClick={() => {
                        setConfirmationModal({
                          text1: "Do you want to delete this course?",
                          text2:
                            "All the data related to this course will be deleted",
                          btn1Text: "Delete",
                          btn2Text: "Cancel",
                          btn1Handler: !loading
                            ? () => {
                                handleCourseDelete(course._id);
                              }
                            : () => {},
                          btn2Handler: !loading
                            ? () => {
                                setConfirmationModal(null);
                              }
                            : () => {
                                setConfirmationModal(null);
                                // console.log("Hello");
                              },
                        });
                      }}>
                      Delete <MdDelete />
                    </button>
                  </Td>
                </Tr>
                // <Tr key={course._id}
                // className="flex gap-x-10 border-b border-richblack-800 px-6 py-8">
                //     <Td className="flex flex-1 gap-x-4">
                //   <img
                //     src={course?.thumbnail}
                //     alt={course?.courseName}
                //     className="h-[148px] w-[220px] rounded-lg object-cover"
                //   />
                //   <div className="flex flex-col justify-between">
                //     <p className="text-lg font-semibold text-richblack-5">
                //       {course.courseName}
                //     </p>
                //     <p className="text-xs text-richblack-300">
                //       course.courseDescription
                //     </p>
                //     <p className="text-[12px] text-white">
                //       Created:
                //     </p>
                //     {course.status === COURSE_STATUS.DRAFT ? (
                //       <p className="flex w-fit flex-row items-center gap-2 rounded-full bg-richblack-700 px-2 py-[2px] text-[12px] font-medium text-pink-100">
                //         <FaRegClock size={14} />
                //         Drafted
                //       </p>
                //     ) : (
                //       <p className="flex w-fit flex-row items-center gap-2 rounded-full bg-richblack-700 px-2 py-[2px] text-[12px] font-medium text-yellow-100">
                //         <div className="flex h-3 w-3 items-center justify-center rounded-full bg-yellow-100 text-richblack-700">
                //           <FaCheck size={8} />
                //         </div>
                //         Published
                //       </p>
                //     )}
                //   </div>
                // </Td>
                // <Td className="text-sm font-medium text-richblack-100">
                //   2hr 30min
                // </Td>
                // <Td className="text-sm font-medium text-richblack-100">
                //   ₹{course.price}
                // </Td>
                // <Td className="text-sm font-medium text-richblack-100 ">
                //   <button
                //     disabled={loading}
                //     onClick={() => {
                //       navigate(`/dashboard/edit-course/${course._id}`)
                //     }}
                //     title="Edit"
                //     className="px-2 transition-all duration-200 hover:scale-110 hover:text-caribbeangreen-300"
                //   >
                //     <MdModeEdit size={20} />
                //   </button>
                //   <button
                //     disabled={loading}
                //     onClick={() => {
                //       setConfirmationModal({
                //         text1: "Do you want to delete this course?",
                //         text2:
                //           "All the data related to this course will be deleted",
                //         btn1Text: !loading ? "Delete" : "Loading...  ",
                //         btn2Text: "Cancel",
                //         btn1Handler: !loading
                //           ? () => handleCourseDelete(course._id)
                //           : () => {},
                //         btn2Handler: !loading
                //           ? () => setConfirmationModal(null)
                //           : () => {},
                //       })
                //     }}
                //     title="Delete"
                //     className="px-1 transition-all duration-200 hover:scale-110 hover:text-[#ff0000]"
                //   >
                //     <MdDelete size={20} />
                //   </button>
                // </Td>
                // </Tr>
              );
            })
          )}
        </Tbody>
      </Table>

      {confirmationModal && <ConfirmationModal modalData={confirmationModal} />}
    </div>
  );
}

export default CourseTable;
